import { render, staticRenderFns } from "./ClubbingOfSemenDosePage.vue?vue&type=template&id=c5782dce&scoped=true&"
import script from "./ClubbingOfSemenDosePage.vue?vue&type=script&lang=js&"
export * from "./ClubbingOfSemenDosePage.vue?vue&type=script&lang=js&"
import style0 from "./ClubbingOfSemenDosePage.vue?vue&type=style&index=0&id=c5782dce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5782dce",
  null
  
)

export default component.exports